var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vca-row',[_c('vca-card',{staticClass:"shadowed"},[_c('General')],1),_c('vca-card',{staticClass:"shadowed"},[_c('Crew'),_c('Newsletter')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }